import React from "react";
import PropTypes from "prop-types";
import {
    Button,
    ButtonGroup,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";
import ReactTooltip from "react-tooltip";
import { MenuProvider } from "react-contexify";

class WorkerCell extends React.Component {
    render() {
        const {
            worker,
            hasHelperJob,
            onWorkerSearchClick,
            onWorkerReplaceClick,
            onWorkerDetailsClick,
            onWorkerToggleTemporaryClick,
            onWorkerAddClick,
            onWorkerRemoveClick,
            hideActions
        } = this.props;

        const roleIconClass = worker.isSpecialProjects ? "user-tag" : "user";
        const roleIconColor = worker.isTeamLead ? "green" : "blue";
        const role = worker.isTeamLead ? "Team Leader" : "Helper";

        const displayTempStatus = () => (
            <FontAwesomeIcon
                icon="hourglass-half"
                size="lg"
                title="Temporary Assignment"
            />
        );
        const removeConfirmText = `Removing worker < ${worker.name} >. Are you sure?`;

        const displayActions = worker => (
            <ButtonGroup>
                <Button size="sm" onClick={() => onWorkerSearchClick(worker.rowId, worker.id)}>
                    <FontAwesomeIcon icon="search" title="Search / Replace"/>
                </Button>
                <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => onWorkerToggleTemporaryClick(
                        worker.draftScheduleDetailsId,
                        worker.rowId,
                        worker.id,
                        !worker.isTemporary
                    )}
                >
                    <FontAwesomeIcon icon="hourglass-half"/>
                </Button>
                <div>
                    <Popconfirm
                        title={removeConfirmText}
                        onConfirm={onWorkerRemoveClick}
                        placement="topRight"
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button variant="warning" size="sm">
                            <FontAwesomeIcon icon="user-minus"/>
                        </Button>
                    </Popconfirm>

                    {hasHelperJob ? (
                        <Button variant="success" size="sm" onClick={onWorkerAddClick}>
                            <FontAwesomeIcon icon="user-plus"/>
                        </Button>
                    ) : null}
                </div>
            </ButtonGroup>
        );

        let tooltip = null;
        if (worker.availability && Array.isArray(worker.availability.details)) {
            tooltip = worker.availability.details.map((item, key) =>
                <div key={key}>{item}</div>);
        }

        return (
            <React.Fragment>
                <td style={{ width: "30px" }}>
                    {tooltip
                        ? (
                            <div>
                                <FontAwesomeIcon
                                    icon={roleIconClass}
                                    color={roleIconColor}
                                    size="lg"
                                    data-tip
                                    data-for={`worker-icon-${worker.rowId}`}
                                />
                                <ReactTooltip id={`worker-icon-${worker.rowId}`} effect='float'>
                                    <div className="text-left">
                                        <div className="border-bottom font-weight-bold">
                                            {role}
                                        </div>
                                        {tooltip}
                                    </div>
                                </ReactTooltip>
                            </div>
                        )
                        : <FontAwesomeIcon icon={roleIconClass} color={roleIconColor} size="lg" title={role}/>
                    }
                </td>
                <td>
                    {hideActions ?
                        <a
                            title="Show details"
                            onClick={onWorkerDetailsClick}
                        >
                            {worker.name}
                        </a>
                        :
                        <MenuProvider
                            id="worker-context-menu-id"
                            data={{
                                callback: onWorkerReplaceClick,
                                id: worker.id,
                                rowId: worker.rowId,
                                name: worker.name,
                                actionType: "replaceAll"
                            }}
                        >
                            <a
                                title="Show details"
                                onClick={onWorkerDetailsClick}
                            >
                                {worker.name}
                            </a>
                        </MenuProvider>
                    }
                </td>
                <td style={{
                    width: 30
                }}>
                    {!worker.isTemporary || displayTempStatus()}
                </td>
                <td style={{
                    width: 120,
                    textAlign: "right"
                }}>
                    {hideActions || displayActions(worker)}
                </td>
            </React.Fragment>
        );
    }
}

WorkerCell.propTypes = {
    worker: PropTypes.object.isRequired,
    onWorkerDetailsClick: PropTypes.func,
    onWorkerSearchClick: PropTypes.func,
    onWorkerReplaceClick: PropTypes.func,
    onWorkerToggleTemporaryClick: PropTypes.func,
    onWorkerAddClick: PropTypes.func,
    onWorkerRemoveClick: PropTypes.func,
    hideActions: PropTypes.bool
};

export default WorkerCell;
